import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
import RatingAndReviewsWrapper from './RatingAndReviewsWrapper';
const RatingAndReviewsPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <RatingAndReviewsWrapper><Placeholder type="rect" loading={true} style={{
        height: "17px",
        width: "83px"
      }} /></RatingAndReviewsWrapper>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default RatingAndReviewsPlaceholder;